import { baseUrl } from "@clockwise/client-commons/src/constants/help-center";
import { Link } from "@clockwise/design-system";
import React from "react";
import { EventElementsWrap } from "../atoms/EventElementsWrap";

export const ECPrivateEventCallout = () => {
  return (
    <div className="cw-pb-2">
      <EventElementsWrap name="locked">
        <span className="cw-body-sm cw-font-medium cw-ml-[5px]">
          You don't have access to events on this calendar.{" "}
          <Link href={baseUrl} target="_blank" rel="noreferrer">
            Learn more
          </Link>
        </span>
      </EventElementsWrap>
    </div>
  );
};
